import React from 'react';
import Helmet from 'react-helmet';
import './docs-template.scss';
import './tables.css';

// <!-- <div id="commento"></div> -->
// <!-- <script src="https://cdn.commento.io/js/commento.js"></script> -->


export default function Template({data}) {
    const { markdownRemark: doc} = data;

    return (
        <div className='docs-container pure-table pure-table-bordered'>
            <Helmet title={`Datasert - ${doc.frontmatter.title}`} />

            <h2>{doc.frontmatter.title}</h2>
            <div className='content' dangerouslySetInnerHTML={{__html: doc.html}}/>
        </div>
    )
}

export const postQuery = graphql`
    query DocsByPath($path: String!) {
        markdownRemark(frontmatter: {path: { eq: $path}}) {
            html
            frontmatter {
                path
                title
            }
        }
    }
`


// WEBPACK FOOTER //
// ./src/templates/docs-template.jsx